module.exports = __webpack_public_path__ + "img/756fa57.png";